<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('close')" />
    <div class="modal">
      <div class="title-close">
        <h1 class="modal-title">What is "Sale Status"?</h1>
        <span class="material-icons" @click="$emit('close')"> close </span>
      </div>
      <div class="description">
        The ability to change these statuses is a new feature to allow organizers quick and easy
        management.
      </div>
      <div class="items-container">
        <div class="item">
          <color-toggle-button label="On Hold" type="regular" />
          <div>
            The ticket type will be available from the specified time. You can mark them as
            immediately available by clicking the toggle.
          </div>
        </div>
        <div class="item">
          <color-toggle-button label="Available" type="successful" :value="true" />
          <div>Tickets for this type are currently available for purchase.</div>
        </div>
        <div class="item">
          <color-toggle-button label="Sold Out" type="disabled" />
          <div>
            All tickets for this type have been sold, and no more are available for purchase.
          </div>
        </div>
        <div class="item">
          <color-toggle-button label="Closed" type="disabled" />
          <div>Selling for this ticket type is closed.</div>
        </div>
      </div>
      <div class="button-container">
        <main-button style="max-width: 3rem" @click="$emit('close')"> OK </main-button>
      </div>
    </div>
  </div>
</template>

<script>
import ColorToggleButton from '@/components/shared/inputs/color-toggle-button.vue'

export default {
  name: 'sale-status-modal',
  components: { ColorToggleButton },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}
.modal {
  text-align: left;
  background-color: white;
  width: 100%;
  position: relative;
  max-width: 40.75rem;
  padding: 2rem;
  border-radius: 20px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.modal::-webkit-scrollbar {
  display: none;
}
.modal-title {
  color: #0277bd;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.0375rem;
}
@media screen and (max-width: 700px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    border-radius: 0;
  }
}
.title-close {
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.material-icons {
  cursor: pointer;
}
.description {
  margin-top: 0.75rem;
  color: #979797;
  font-family: 'Source Sans Pro';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
.items-container {
  margin-top: 1.5rem;
}
.item {
  display: flex;
  padding: 0.75rem 0;
  align-items: flex-start;
  gap: 1.5rem;
  align-self: stretch;
  border-top: 1px solid #f5f5f5;
}
.button-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem;
}
</style>
